import { useCallback, useEffect, useState } from "react"
import { useLocation } from "react-router-dom"
import { getCustomer } from "../../include/function"
import CustomerPersonalInfo from "../../components/user/PersonalInfo"
import CustomerOrders from "../../components/user/Orders"
import CustomerAddress from "../../components/user/Address"
import CustomerChangePassword from "../../components/user/ChangePassword"
import Layout from "../../components/user/Layout"
import { ShoppingCart, Heart, Bookmark, Headphones, Bell, Star, HelpCircle, LogOut, ChevronRight, Edit, LocationEditIcon, Wallet, Lock } from 'lucide-react';
import { useNavigate } from "react-router-dom";
const MENU_ITEMS = [
    {
        key: "personal-info",
        text: "Edit Profile",
        icon: "user",
        body: <CustomerPersonalInfo />
    },
    {
        key: "address",
        text: "Saved Addresses",
        icon: "map-pin",
        body: <CustomerAddress />
    },
    {
        key: "orders",
        text: "Your Orders",
        icon: "shopping-cart",
        body: <CustomerOrders />
    },
    {
        key: "change-password",
        text: "Change Password",
        icon: "key",
        body: <CustomerChangePassword />
    }
];
const CustomerProfile = () => {
    const user = getCustomer();
    const navigate = useNavigate();
    const [activeKey, setActiveKey] = useState("personal-info");

    const getCurrentBody = () => {
        const item = MENU_ITEMS.find(item => item.key === activeKey);
        return item ? item.body : MENU_ITEMS[0].body;
    };

    return (
        <Layout>
            <div className="container-fluid row ps-40 py-60 ">
                <div className="col-4">
                    <div className="d-flex rounded-12 p-18 hstack gap-16 mb-16" style={{ background: "#ECF3F9" }}>
                        <div className="fw-bold"
                            style={{ backgroundColor: "#BBCEDD", color: "white", width: "75px", height: "75px", borderRadius: "50%", textAlign: "center", textJustify: "center", fontSize: "50px" }}>
                            {user?.name ? user.name.charAt(0).toUpperCase() : 'A'}
                        </div>
                        <div>
                            <h6 className="fw-bold text-lg text-capitalize text-dark mb-1">{user?.name || 'User'}</h6>
                            <h6 className="text-md text-capitalize mb-1" style={{ color: "#6792B2" }}>{user?.customerType}</h6>
                            <h6 className="fw-semibold text-sm mb-1">+91 {user?.phoneNumber}</h6>
                        </div>
                    </div>

                    <div className="bg-white rounded-lg rounded-12 border border-gray-100 mb-16">
                        <div className="ps-26 pe-26 pt-28 pb-12">
                            <button className="w-100 d-flex align-items-center justify-content-between border-0 bg-transparent"
                                onClick={() => navigate('/orders')}
                            >
                                {/* Left side - cart + text */}
                                <span className="d-flex align-items-center">
                                    <ShoppingCart className="me-16" />
                                    <h6 className="text-md mb-0">YOUR ORDERS</h6>
                                </span>

                                {/* Right side - chevron */}
                                <ChevronRight />
                            </button>
                        </div>
                        <hr />
                        <div className="ps-26 pe-26 pt-12 pb-12">
                            <button className="w-100 d-flex align-items-center justify-content-between border-0 bg-transparent"
                                onClick={() => navigate('/wishlist')}>
                                <span className="d-flex align-items-center">
                                    <Heart className="me-16" />
                                    <h6 className="text-md mb-0">WISHLIST</h6>
                                </span>
                                <ChevronRight />

                            </button>
                        </div>
                        <hr />
                        <div className="ps-26 pe-26 pt-12 pb-12">
                            <button
                                className="w-100 d-flex align-items-center justify-content-between border-0 bg-transparent"
                                onClick={() => navigate('/cart#saved-for-later')}
                            >
                                <span className="d-flex align-items-center">
                                    <Bookmark className="me-16" />
                                    <h6 className="text-md mb-0">SAVE FOR LATER</h6>
                                </span>
                                <ChevronRight />
                            </button>
                        </div>
                        <hr />
                        <div className="ps-26 pe-26 pt-12 pb-12">
                            <button
                                className="w-100 d-flex align-items-center justify-content-between border-0 bg-transparent text-start"
                                onClick={() => setActiveKey("change-password")}
                            >
                                <span className="d-flex align-items-center">
                                    <Lock className="me-16" />
                                    <h6 className="text-md mb-0">CHANGE PASSWORD</h6>
                                </span>
                                <ChevronRight />
                            </button>
                        </div>
                        <hr />
                        <div className="ps-26 pe-26 pb-26 pt-12">
                            <button className="w-100 d-flex align-items-center justify-content-between border-0 bg-transparent">
                                <span className="d-flex align-items-center">
                                    <Headphones className="me-16" />
                                    <h6 className="text-md mb-0">HELP CENTER</h6>
                                </span>
                                <ChevronRight />
                            </button>
                        </div>
                    </div>
                    <div className="bg-white rounded-lg rounded-12 border border-gray-100 mb-16">
                        <h6 className="p-32 fw-bold text-lg">Account Settings</h6>
                        <div className="ps-26 pe-26 pb-12">
                            <button
                                className="w-100 d-flex align-items-center justify-content-between border-0 bg-transparent text-start"
                                onClick={() => setActiveKey("personal-info")}
                            >
                                <span className="d-flex align-items-center">
                                    <Edit className="me-16" />
                                    <h6 className="text-md mb-0">EDIT PROFILE</h6>
                                </span>
                                <ChevronRight />
                            </button>
                        </div>
                        <hr />
                        <div className="ps-26 pe-26 pt-12 pb-12">
                            <button
                                className="w-100 d-flex align-items-center justify-content-between border-0 bg-transparent text-start"
                            >
                                <span className="d-flex align-items-center">
                                    <Wallet className="me-16" />
                                    <h6 className="text-md mb-0">SAVED CARDS & WALLETS</h6>
                                </span>
                                <ChevronRight />
                            </button>
                        </div>
                        <hr />
                        <div className="ps-26 pe-26 pt-12 pb-12">
                            <button
                                className="w-100 d-flex align-items-center justify-content-between border-0 bg-transparent text-start"
                                onClick={() => setActiveKey("address")}
                            >
                                <span className="d-flex align-items-center">
                                    <LocationEditIcon className="me-16" />
                                    <h6 className="text-md mb-0">SAVED ADDRESS</h6>
                                </span>
                                <ChevronRight />
                            </button>
                        </div>
                        <hr />
                        <div className="ps-26 pe-26 pb-26 pt-12" >
                            <button className="w-100 d-flex align-items-center justify-content-between border-0 bg-transparent">
                                <span className="d-flex align-items-center">
                                    <Bell className="me-16" />
                                    <h6 className="text-md mb-0">NOTIFICATION SETTINGS</h6>
                                </span>
                                <ChevronRight />
                            </button>
                        </div>
                    </div>
                    <div className="bg-white rounded-lg rounded-12 border border-gray-100 mb-16">
                        <h6 className="p-32 fw-bold text-lg">My Activity</h6>
                        <div className="ps-26 pe-26 pb-12" >
                            <button className="w-100 d-flex align-items-center justify-content-between border-0 bg-transparent">
                                <span className="d-flex align-items-center">
                                    <Star className="me-16" />
                                    <h6 className="text-md mb-0">RATINGS & REVIEWS</h6>
                                </span>
                                <ChevronRight />
                            </button>
                        </div>
                        <hr />
                        <div className="ps-26 pe-26 pb-26 pt-12" >
                            <button className="w-100 d-flex align-items-center justify-content-between border-0 bg-transparent">
                                <span className="d-flex align-items-center">
                                    <HelpCircle className="me-16" />
                                    <h6 className="text-md mb-0">FAQs</h6>
                                </span>
                                <ChevronRight />
                            </button>
                        </div>
                        <hr className="m-0 p-0" />
                        <hr className="m-0 p-0" />
                        <hr className="m-0 p-0" />

                        <div className="ps-26 pe-26 pb-26 pt-26" >
                            <button className="w-100 d-flex align-items-center justify-content-between border-0 bg-transparent">
                                <span className="d-flex align-items-center ms-80" onClick={() => {
                                    localStorage.removeItem('token');
                                    navigate('/logout');
                                }}>
                                    <LogOut className="me-16" />
                                    <h6 className="text-md mb-0">LOGOUT</h6>
                                </span>
                            </button>
                        </div>
                    </div>
                </div>
                <div className="col-8">
                    <div className="w-100 bg-white rounded-lg rounded-12 border border-gray-100">
                        {getCurrentBody()}
                    </div>
                </div>
            </div>
        </Layout >
    )
}

export default CustomerProfile
